// extracted by mini-css-extract-plugin
module.exports = {"image":"Image_image__3QFzw","elementWrapper":"Image_elementWrapper__GR_pP","placeholder":"Image_placeholder__RrMIe","element":"Image_element__9CPpl","button":"Image_button__BIyT1"};